<template>
  <div>
    <b-modal
      v-model="show"
      :title="$t('Add Recipient Group')"
      modal-class="modal-primary"
      @hidden="close"
      size="lg"
      hide-footer
    >
      <ValidationObserver ref="form-add-recipient-group">
        <b-row>
          <b-col md="6">
            <ValidationProvider
              v-slot="{ errors }"
              name="abrevision"
              rules="required"
            >
              <b-form-group :label="$t('Name')" label-for="name">
                <b-form-input
                  id="name"
                  :state="errors[0] ? false : null"
                  v-model="recipientGroup.name"
                  type="text"
                ></b-form-input>
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </ValidationProvider>
          </b-col>

          <b-col :md="6">
            <ValidationProvider
              v-slot="{ errors }"
              name="description"
              rules="required"
            >
              <b-form-group :label="$t('description')" label-for="description">
                <b-form-input
                  id="description"
                  :state="errors[0] ? false : null"
                  v-model="recipientGroup.description"
                  type="text"
                ></b-form-input>
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </ValidationProvider>
          </b-col>

          <b-col :md="6">
            <ValidationProvider
              v-slot="{ errors }"
              name="description"
              rules="required"
            >
              <b-form-group :label="$t('Status')" label-for="description">
                <!-- switch -->

                <b-form-checkbox
                  v-model="recipientGroup.status"
                  :switch="true"
                  :size="'sm'"
                  :variant="'primary'"
                  :value="1"
                  :unchecked-value="0"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </ValidationProvider>
          </b-col>
        </b-row>

        <b-button
          variant="outline-success"
          @click="storeRecipientGroup"
          class="float-right"
        >
          {{ $t("Save") }}
        </b-button>
      </ValidationObserver>
    </b-modal>
  </div>
</template>

<script>
import RecipientGroupService from "@/views/settings/views/general/components/email/services/email.recipient-groups.service.js";
import { mapGetters } from "vuex";

export default {
  name: "AddRecipientGroup",
  data() {
    return {
      show: true,
      recipientGroup: {
        status: 1,
        name: "",
        description: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
  },
  created() {},
  methods: {
    close() {
      this.$emit("close");
    },
    async storeRecipientGroup() {
      try {
        this.addPreloader();
        const { data } =
          await RecipientGroupService.createOrUpdateRecipientGroup(
            this.recipientGroup
          );
        this.showToastSuccess(data.message);
        this.$emit("save");
      } catch (error) {
        this.showToastError();
      } finally {
        this.removePreloader();
      }
    },
  },
};
</script>

<style></style>
